var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-time-picker',{attrs:{"label":_vm.label || _vm.title,"first-day-of-week":"1","time-format":_vm.timeFormat,"time-buttons":_vm.timeButtons},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }